import { Injectable } from '@angular/core';

/* =============================================================================
   DatelessStateService — forked from the Number Ones state-service PATTERN
   (freshness + restoration mechanics) with a Dateless-specific typed snapshot
   (build pack §3.5). Preserves transient register state across a
   plate-detail round trip; never written to the URL (only the format token
   lives there).
   ========================================================================== */

export type DatelessArrangementFilter = 'both' | 'number-first' | 'letter-first';
export type DatelessSortKey = 'price-asc' | 'price-desc' | 'reg-az';

export interface DatelessSnapshot {
  format: string;                       // canonical token, e.g. "2x1"
  arrangement: DatelessArrangementFilter;
  sort: DatelessSortKey;
  dealer: string | null;
  searchTerm: string;
  page: number;
  resultAnchorId: string | null;
  scrollY: number;
  savedAt: number;
}

const FRESH_MS = 30 * 60 * 1000; // 30 minutes, the register convention

@Injectable({ providedIn: 'root' })
export class DatelessStateService {
  private snapshot: DatelessSnapshot | null = null;

  public save(snapshot: Omit<DatelessSnapshot, 'savedAt'>): void {
    this.snapshot = { ...snapshot, savedAt: Date.now() };
  }

  /** Returns and clears the snapshot if saved within the freshness window. */
  public takeFresh(maxAgeMs: number = FRESH_MS): DatelessSnapshot | null {
    const snap = this.snapshot;
    this.snapshot = null;
    if (!snap) return null;
    return Date.now() - snap.savedAt <= maxAgeMs ? snap : null;
  }
}
